// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MP3 = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MP3 = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var MP3 = _exports.MP3 = function MP3(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M16.927 8.496v8.43a2.08 2.08 0 0 1-2.078 2.079H5.152a2.08 2.08 0 0 1-2.078-2.078V3.074A2.08 2.08 0 0 1 5.152.996h4.275c.367 0 .72.146.98.406l6.114 6.115c.26.26.406.612.406.98Z"
    }), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M10 1.342v5.195a1.385 1.385 0 0 0 1.385 1.385h5.195"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M5 12.05v3.636h.856V13.44h.03l.874 2.223h.546l.874-2.21h.03v2.233h.856V12.05H7.978L7.054 14.3h-.042l-.924-2.251zM9.614 15.686h.88v-1.13h.596c.832 0 1.353-.493 1.353-1.247 0-.748-.51-1.26-1.327-1.26H9.614zm.88-1.822v-1.106h.432c.395 0 .606.213.606.55 0 .336-.211.556-.606.556zM14.252 15.736c.852 0 1.458-.451 1.456-1.083.002-.448-.291-.767-.852-.833v-.029c.42-.06.719-.342.717-.75.002-.594-.534-1.041-1.314-1.041-.785 0-1.356.454-1.364 1.1h.84c.008-.248.231-.415.524-.415.279 0 .469.169.467.412.002.252-.222.426-.545.426h-.353v.625h.353c.368 0 .607.181.604.437.003.258-.217.437-.53.437-.31 0-.54-.165-.548-.405h-.884c.007.657.598 1.119 1.429 1.119"
    }));
  };
});
